import { IAiNoteSource, IAiTemplate } from 'src/ai-note/types'

export function isInstantiated(aiNoteTemplate: IAiTemplate, aiNotes: IAiNoteSource[]): boolean {
  return !!aiNotes.find((aiNote) => aiNoteTemplate.id === aiNote.aiTemplate.id)
}
